import React from 'react';
import { Box, ButtonV2, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { JoyAiV2 } from '@withjoy/joykit/icons';
import { AudioPlayer } from '../AudioPlayer';

const AUDIO_URL = 'https://withjoy.com/assets/public/travel/accommodations-intro.mp3';

interface IntroProps {
  onClickContinue: () => void;
}

export const Intro = ({ onClickContinue }: IntroProps) => {
  const { t } = useTranslation('websiteEditor');
  const introTrans = t('venueIntro');
  return (
    <Flex
      flex={1}
      flexDirection="column"
      gap={9}
      alignItems="center"
      justifyContent="center"
    >
      <Flex
        flexDirection="column"
        gap={5}
        alignItems="center"
        paddingX={{ _: 6, md: 0 }}
      >
        <JoyAiV2 size={64} />
        <Box
          typographyVariant="hed6"
          fontSize={pxToRem(28)}
          fontWeight={600}
          textAlign="center"
          maxWidth={{ _: '100%', md: pxToRem(392) }}
        >
          {introTrans.title()}
        </Box>
        <Box
          typographyVariant="body2"
          textAlign="center"
          maxWidth={{ _: '100%', md: pxToRem(392) }}
        >
          {introTrans.message()}
        </Box>
        <AudioPlayer
          id="AccommodationsIntroAudio"
          url={AUDIO_URL}
          preload="auto"
          width={pxToRem(153)}
        >
          {introTrans.audioCta()}
        </AudioPlayer>
      </Flex>
      <Flex
        width="100%"
        maxWidth={{ _: '100%', md: pxToRem(340) }}
        flexDirection="column"
        justifyContent="center"
        borderTop={{ _: '1px solid', sm2: 'none' }}
        borderTopColor="mono3"
        paddingX={{ _: 6, md: 0 }}
        paddingY={{ _: 5, md: 0 }}
        position={{ _: 'sticky', sm2: 'relative' }}
        backgroundColor="white"
        bottom={0}
        gap={5}
      >
        <ButtonV2
          typographyVariant="button2"
          intent="newPrimary"
          textAlign="center"
          shape="rounded"
          fullWidth
          onClick={onClickContinue}
        >
          {introTrans.cta()}
        </ButtonV2>
      </Flex>
    </Flex>
  );
};
